import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68c52549"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = ["onClick"]

import { ComponentPublicInstance, ref, shallowRef, watch } from 'vue';
import WidgetTablePagination from '@/components/business/crud/table/WidgetTablePagination.vue';
import WidgetTableButton from '@/components/business/crud/table/WidgetTableButton.vue';
import { createCrudTableService } from '@/components/business/crud/service/CrudTableService';
import ScPage from '@/components/common/page/ScPage.vue';
import View from '@/views/management/help/View.vue';
import { windows } from '@/components/common/window/Windows';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const props = { moduleName: 'management', controllerName: 'help' };
const tableService = createCrudTableService(
  props.moduleName,
  props.controllerName
);
const { schema, listData,  buttons } = tableService.use();
tableService.listConfig.addLoad = ["content"];
tableService.init();

const table = ref<ComponentPublicInstance>();

function backTopTarget() {
  return table.value?.$el;
}

function open(record) {
  console.log(record)
  windows.open({
    content: {
      type: 'component',
      component: shallowRef(View),
      props: {
        content: record.content,
      },
    },
    title: record.name,
    width: 1280,
    height: 800,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table_column = _resolveComponent("a-table-column")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createBlock(ScPage, {
    title: _unref(schema).title,
    desc: _unref(schema).desc,
    ref_key: "table",
    ref: table
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WidgetTableButton, { buttons: _unref(buttons) }, null, 8, ["buttons"]),
        _createVNode(_component_a_table, {
          "data-source": _unref(listData).list
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table_column, {
              key: "name",
              title: "问题",
              "data-index": "name"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (open(scope.record))
                }, [
                  _createVNode(_component_a_button, { type: "link" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.record.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-source"]),
        _createVNode(WidgetTablePagination, {
          count: _unref(listData).count,
          "page-num": _unref(tableService).listConfig.pageNum,
          "onUpdate:pageNum": _cache[0] || (_cache[0] = ($event: any) => ((_unref(tableService).listConfig.pageNum) = $event)),
          "page-size": _unref(tableService).listConfig.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(tableService).listConfig.pageSize) = $event))
        }, null, 8, ["count", "page-num", "page-size"]),
        _createVNode(_component_a_back_top, {
          target: backTopTarget,
          visibilityHeight: 100
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "desc"]))
}
}

})